import { ThisReceiver } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(public storage: StorageService){

  }

  save(reg: string, value: any){

    this.storage.save(reg, value)

  }

 

  delete(reg: any): void{

      this.storage.delete(reg)
  }

}
